import { render, staticRenderFns } from "./EN_About.vue?vue&type=template&id=c035ce7a&"
import script from "./EN_About.vue?vue&type=script&lang=js&"
export * from "./EN_About.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports